/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function BenefisCategoryEditDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { benefisCategoryForEdit, actionsLoading } = useSelector(
    (state) => ({
      benefisCategoryForEdit: state.benefisCategory.benefisCategoryForEdit,
      actionsLoading: state.channels.actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "Tambah Kategori Penerima Manfaat";
    if (benefisCategoryForEdit && id) {
      _title = "Edit BenefisCategory";
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [benefisCategoryForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
